<template>

  <div style="background-color:#fff;height: 100%;">
    <van-sticky :offset-top="0 " >

      <mini_head_top v-if = "tokenObj.token != null && tokenObj.token  != ''"> </mini_head_top>
      <div v-else class="header_container">
        <van-row type="flex"  justify="space-between" style="height: 40px;">
          <van-row type = "flex" style ="margin:2px" >
            <div><van-image width="40px" :src ="logo"/></div>
            <div class="grid-content"  ><div>天津大学浙江研究院</div><div>实验室安全教育培训与管理系统</div></div>
          </van-row>
          <div>
          </div>
        </van-row>
        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0', margin:'2px' }">
        </van-divider>
      </div>
    </van-sticky>
    <van-row  type="flex"  justify="space-between" style="margin-left :0px; padding: auto; margin-top: 10px; width: 100%;text-align: left">
      <van-col :span= '20'>
        <span style="margin-left: 0px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
        <span style="font-size:16px; font-weight:700">{{ theme }}</span>
      </van-col>
      <van-col >
        <el-link :span= '4' style="margin-right: 10px;" type="primary" @click.native="goHome()">主页 <i class= "el-icon-s-home"> </i></el-link>
      </van-col>   
    </van-row>
    <van-row  type="flex"  justify="begin" style="margin-left:15px" >
      <el-checkbox  v-model="basicState" disabled >实验室准入教程</el-checkbox>
    </van-row>
    <div class = "w-e-text-container"  style="height:calc(80vh - 230px);overflow:auto;">
      <div data-slate-editor style="overflow:auto !important;" v-html="content">
      </div>
    </div>
    <div style=" height: 216px; margin-top: 10px; " v-if=" funtFootType==3"  >
      <div style="margin-left:10px">
        <canvas style="background-color: #efd;"  ref="canvas" @touchstart="startDrawing" @touchmove="draw" @touchend="stopDrawing">
        
        </canvas>
      </div>
      <div style=" margin-left:10px ;margin-top: 10px; text-align: center;" >
        <el-button @click="clearCanvas"  size="mini" type ="danger">清除签名</el-button>
        <el-button @click="saveSignature" size="mini" type ="primary">保存签名</el-button>
      </div>
    </div>
    <div style="  height: 216px; text-align: center;  margin-top: 10px; " v-else-if=" funtFootType==2" >
      <div>
        <el-image :src ="fileUrl" fit ="fit" style= "border: 1px solid black; width:90%;height: 150px;"> 
        </el-image>
      </div>
    </div>
  </div>
</template>                     
<script>
// 引入组
import '@wangeditor/editor/dist/css/style.css'
import {getToken} from  '@/api/utils'
import axios from  '@/api/axiosConfig'
import mini_head_top from "@/mini_pages/mini_head_top"
import {TOKEN_ID} from '@/mutation/mutConst'
import {MESSAGE_DURATION} from  '@/api/constant'
import logo from "@/assets/image/yuanhui.png"
export default {
  name : 'mini_safe_book_editor',
  data() {
    return {
      logo,
      basicState : false,
      funtFootType :'', // 1  文件 /2 图片 / 3 画布
      isDrawing: false, // 是否正在绘制
      context: null, // Canvas上下文
      id :"",
      theme : "",
      content:"",
      fileName:'',
      fileType : "",
      fileUrl :'',
      code:'',
      tokenObj:{
        token :''
      }
    }
  },
  methods : {
    goHome(){
      if(this.tokenObj.token != null && this.tokenObj.token!= ''){
        this.$router.push({path:'/mini_index'})
      }else{
        this.$router.push({path:'/mini_login'})
      }
    },
    // 鼠标按下时触发
    startDrawing(e) {
      this.isDrawing = true; // 开始绘制
      let offsetX = e.touches[0].clientX - e.target.offsetLeft,
      offsetY= e.touches[0].clientY - e.target.offsetTop;
      this.context.beginPath(); // 开始新的路径
      this.context.moveTo(offsetX, offsetY); // 将路径移动到鼠标位置
    },
    // 当鼠标在 Canvas 上移动时触发
    draw(e) {
      if (!this.isDrawing) return; // 如果没有在绘制中，则返回
      let offsetX = e.touches[0].clientX - e.target.offsetLeft,
      offsetY= e.touches[0].clientY - e.target.offsetTop;
      this.context.lineTo(offsetX, offsetY); // 绘制路径
      this.context.stroke(); // 绘制路径的边框
    },
    // 当鼠标松开时触发，用于停止绘制签名
    stopDrawing() {
      this.isDrawing = false; // 停止绘制
    },
    // 清除
    clearCanvas() {
      this.context.clearRect(
        0,
        0,
        this.$refs.canvas.width,
        this.$refs.canvas.height
      ); // 清除Canvas上的内容
    },
    // 保存
    saveSignature() {
       if( this.isCanvasBlank(this.$refs.canvas) ){
        this.$message({
            showClose: true,
            message:"您未签名！",
            type: 'error',
            duration: MESSAGE_DURATION
          })
         return
       }
      const dataURL = this.$refs.canvas.toDataURL(); // 获取签名图片的Base64编码
      // 在这里可以将dataURL发送到服务器保存，或者进行其他操作
      let file = this.dataURLtoFile(dataURL )
      let url = "/bc/exa/safeBook/signSafeBook"
      let param =  new FormData()
      param.append('safeBookId',this.id)
      param.append('code',this.code) 
      param.append('file',file)
      axios.post(url, param,{
        headers: {
          'Content-Type': 'multipart/form-data',
          'token': this.tokenObj.token
        }
      }).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '签名成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    dataURLtoFile(dataurl, filename = 'file') {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let suffix = mime.split('/')[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    },
    safeBookOneLoad(id,code){
      let url = "/bc/exa/safeBook/getSafeBookInfo"
      let dat0 = {
        id: id,
        code: code,
        student:true
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            this.content= response.data.data.content 
            this.theme = response.data.data.theme
            let fileTreeId = response.data.data.fileTreeId
            this.id = response.data.data.id
            this.basicState = response.data.data.basicState == 1
            console.log(response) 
            if(fileTreeId != null && fileTreeId != '' ){
              this.funtFootType = 2
              this.fileUrl = response.data.data.signImage
            }else{
              this.funtFootType = 3
              setTimeout(()=>{
                this.context = this.$refs.canvas.getContext("2d"); // 获取Canvas上下文
                this.context.strokeStyle = '#000';   // 颜色
                this.context.lineWidth = 5; 
                this.$refs.canvas.width = document.body.clientWidth - 20; // 设置Canvas的宽度
                this.$refs.canvas.height = 160; // 设置Canvas的高
              },200)
            }

          } else {
            this.$message({
                showClose: true,
                message: '未查询相关信息！',
                type: 'info',
                duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },
    isCanvasBlank(canvas) {
      var blank = document.createElement('canvas');//系统获取一个空canvas对象
      blank.width = canvas.width;
      blank.height = canvas.height;
      return canvas.toDataURL() == blank.toDataURL();//比较值相等则为空
    }
  },
  created () { 
    this.id = this.$route.query.id
    this.code = this.$route.query.code
    console.log("CODE==>" + this.code)
    console.log("id==>" + this.id)
    if(this.id != null && this.id != ''){
      setTimeout(()=>{getToken(this.tokenObj)},200)
      this.safeBookOneLoad(this.id,'')
    }else{
      this.$store.commit(TOKEN_ID, '')
      this.safeBookOneLoad('',this.code)
    }
  },
  mounted() {
   
  },
  components:{
    mini_head_top
  }
}
</script>

<style lang="less" scoped>
       .grid-content{
    margin-top: 4px;
    margin-left: 1px;
    text-align: center;
    font-weight: 700;
    color: #0162c3 ;
    font-size: 0.8em;
  }
.el-card {
  height: 99%

}
/deep/.el-card__body {
  padding-top:0px;
}
.text {
  font-size: 14px;
  color: #000;
}

.notice-content-view {
  border: 3px solid #ccc;
  border-radius: 5px;
  padding: 0 10px;
  margin-top: 20px;
  overflow-x: auto;
}

.notice-content-view p,
.notice-content-view li {
  white-space: pre-wrap; /* 保留空格 */
}

.notice-content-view blockquote {
  border-left: 8px solid #d0e5f2;
  padding: 10px 10px;
  margin: 10px 0;
  background-color: #f1f1f1;
}

.notice-content-view code {
  font-family: monospace;
  background-color: #eee;
  padding: 3px;
  border-radius: 3px;
}
.notice-content-view pre>code {
  display: block;
  padding: 10px;
}

.notice-content-view table {
  border-collapse: collapse;
}
.notice-content-view td,
.notice-content-view th {
  border: 1px solid #ccc;
  min-width: 50px;
  height: 20px;
}
.notice-content-view th {
  background-color: #f1f1f1;
}

.notice-content-view ul,
.notice-content-view ol {
  padding-left: 20px;
}

.notice-content-view input[type="checkbox"] {
  margin-right: 5px;
}
.el-divider--horizontal{
  background-color: #2577d5;
  height: 3px;
  margin: 1px 0 1px 0;
  width: 100%
}
</style>
    


// WEBPACK FOOTER //
// src/mini_pages/mini_safe_book_editor.vue